export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "OutletMasterImportWorker.012ffdc5eae0926f5103.worker.js");
}
